// extracted by mini-css-extract-plugin
module.exports = {"dowSelector":"DayOfTheWeekSelector_dowSelector__2U2JC","dayButton":"DayOfTheWeekSelector_dayButton__1oYaZ"};